import { useMutation } from '@tanstack/react-query';

import { generateAdminEsimPromo } from '~/services/LuxLoyalty';

export function useGenerateAdminEsimPromo() {
  return useMutation({
    mutationFn: generateAdminEsimPromo,
  });
}
